import { render, staticRenderFns } from "./AppLinkPage.vue?vue&type=template&id=51c51e34&scoped=true"
import script from "./AppLinkPage.vue?vue&type=script&lang=js"
export * from "./AppLinkPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c51e34",
  null
  
)

export default component.exports